
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/privacy",
      function () {
        return require("private-next-pages/info/privacy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/privacy"])
      });
    }
  